<template>
	<div>
		<BAlert v-if="moment().diff(moment(updatedAt), 'days') > 7" :variant="getVariant"
			:model-value="['1st Dose', '2nd Dose', 'Waiting on appointment'].includes(original_status)">
			<h3>Vaccination Status</h3>
			<div class="d-md-flex">
				<template v-if="original_status === '1st Dose'">
					<p>
						Our records indicate you are waiting on your second (2nd) vaccine dose. Please click the button
						to the right once you have received your second dose so that we can update our records.
					</p>
					<BButton variant="primary" class="ml-md-4"
						@click="hadSecondDose">
						I've had my second dose.
					</BButton>
				</template>
				<template v-if="original_status === '2nd Dose'">
					<p>
						Our records indicate you are waiting on your booster shot. Please click the button to the right
						once you have received your booster shot so that we can update our records.
					</p>
					<BButton variant="primary" class="ml-md-4"
						@click="hadBoosterShot">
						I've had my booster shot.
					</BButton>
				</template>
				<template v-if="original_status === 'Waiting on appointment'">
					<p>
						Our records indicate you are currently waiting for your 1st vaccination appointment. Please
						click the button to the right to update your vaccination status once you've had your 1st dose
						appointment.
					</p>
					<BButton variant="primary" @click="hadFirstDose">
						I've had my first dose.
					</BButton>
				</template>
			</div>
		</BAlert>
		<BAlert
			v-if="!original_status || ['Prefer not to say', 'Not getting vaccinated'].includes(original_status) || forceShow"
			:variant="getVariant"
			:model-value="true">
			<h3>Vaccination Status</h3>

			<p>
				As part of the ongoing COVID19 situation we need to know your vaccination status.
			</p>
			<BFormGroup v-slot="{ ariaDescribedby }">
				<div v-for="(option, index) in vaccinationStatusOptions"
					:key="option.value"
					class="custom-control custom-radio">
					<input
						:id="`vaccination-status-${index}`"
						:aria-describedby="ariaDescribedby"
						:checked="status === option.value"
						:value="option.value"
						class="custom-control-input"
						name="some-radios"
						type="radio"
						@change="status = option.value">
					<label class="custom-control-label" :for="`vaccination-status-${index}`">
						{{ option.text }}
					</label>
				</div>
			</BFormGroup>
			<h5>How will we use this information?</h5>
			<ul>
				<li>
					Vaccination status will be used to match you with clients who are requesting vaccinated
					cleaners.
				</li>
				<li>
					Absolute Domestics clients will be able to see your vaccination status if you are rostered to
					them.
				</li>
			</ul>
			<div class="d-flex justify-content-end">
				<div class="text-right custom-control custom-checkbox">
					<input
						id="agree-terms"
						:checked="agree_terms"
						class="custom-control-input"
						name="agree-terms"
						type="checkbox"
						@change="agree_terms = $event.target.checked">
					<label class="custom-control-label" for="agree-terms">
						I agree for Absolute Domestics Pty Ltd to store and disclose my vaccination status inline with
						the
						<a href="https://www.absolutedomestics.com.au/privacy-policy" class="text-black-50">Privacy
							Policy.
						</a>
					</label>
				</div>
				<BButton variant="primary" class="ml-auto"
					@click="updateStatus">
					Submit
				</BButton>
			</div>
		</BAlert>
	</div>
</template>

<script>
	export default {
		name: 'VaccinationStatus',
		props: {
			forceShow: {
				type: Boolean,
				default: false,
			},
			variant: {
				type: String,
				default: null,
				required: false,
			}
		},
		data() {
			return {
				status: '',
				original_status: '',
				agree_terms: false,
				show: false,
				showSecondDoseUpdate: false,
				vaccinationStatusOptions: [
					{ value: '1st Dose', text: 'I\'ve had my first (1st) dose.' },
					{ value: '2nd Dose', text: 'I\'ve had my second (2nd) dose.' },
					{ value: 'Booster Shot', text: 'I\'ve had my Booster Shot.' },
					{ value: 'Waiting on appointment', text: 'I\'m waiting on an appointment.' },
					{ value: 'Not getting vaccinated', text: 'I\'m not getting vaccinated.' },
					{ value: 'Prefer not to say', text: 'Prefer not to say.' },
				],
			}
		},
		computed: {
			getVariant() {
				if (this.variant) {
					return this.variant;
				}

				return this.hasAlreadySetStatus ? 'light' : 'primary'
			},
			hasAlreadySetStatus() {
				return this.$store.getters['auth/user'].vaccination_status && this.$store.getters['auth/user'].vaccination_status_updated_at;
			},
			updatedAt() {
				return this.$store.getters['auth/user'].vaccination_status_updated_at;
			}
		},
		mounted() {
			this.original_status = this.$store.getters['auth/user'].vaccination_status;
			this.status = this.$store.getters['auth/user'].vaccination_status;
		},
		methods: {
			hadFirstDose() {
				this.status = '1st Dose';
				this.agree_terms = 1;

				this.updateStatus();
			},
			hadSecondDose() {
				this.status = '2nd Dose';
				this.agree_terms = 1;

				this.updateStatus();
			},
			hadBoosterShot() {
				this.status = 'Booster Shot';
				this.agree_terms = 1;

				this.updateStatus();
			},
			updateStatus() {
				this.$axios.put('/api/account/vaccination-status', {
					status: this.status,
					agree_terms: this.agree_terms
				}).then(() => {
					toastr.success('Vaccination status updated.')
					this.$store.dispatch('auth/fetchCurrentUser')
					this.original_status = this.status;
				}).catch((error) => {
					if (error.response.status === 422) {
						let errors = Object.keys(error.response.data.errors).map((res) => {
							return error.response.data.errors[res][0];
						});

						toastr.error(errors.join('\n'));

						return;
					}
					toastr.error('An unexpected error occurred.')
					throw error;
				})
			}
		}
	}
</script>

<style scoped>

</style>
